import { render, staticRenderFns } from "./app-container.vue?vue&type=template&id=1a2e30d6"
import script from "./app-container.vue?vue&type=script&lang=ts"
export * from "./app-container.vue?vue&type=script&lang=ts"
import style0 from "./app-container.vue?vue&type=style&index=0&id=1a2e30d6&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/volateq-web-app/volateq-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2e30d6')) {
      api.createRecord('1a2e30d6', component.options)
    } else {
      api.reload('1a2e30d6', component.options)
    }
    module.hot.accept("./app-container.vue?vue&type=template&id=1a2e30d6", function () {
      api.rerender('1a2e30d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/shared/components/app-container/app-container.vue"
export default component.exports